import { atom } from 'jotai'
import { DEFAULT_REGION } from '~/models/generalConstants'
import { RegionCode } from '~/types'

export const regionAtom = atom(DEFAULT_REGION)
export const regionModalAtom = atom(false)
export const allowedRegionAtom = atom<RegionCode | null | undefined>(undefined)